// Censor dashboard
import React, { useCallback, useState } from 'react';
import View from 'src/pages/censors/overview';
import AppRender from 'src/routes/app-render';
import { tmsApi, fuelApi, repairApi } from 'src/api/censors/vm-view';

export const Page = () => {
  
  const [tmsData, setTmsData] = useState();
  const [fuelData, setFuelData] = useState();
  const [repairData, setRepairData] = useState();

  const fetchData = useCallback(async () => {
    tmsApi.getItemNew(
      (result) => {
        setTmsData(result);
      }
    );
    fuelApi.getItemNew(
      (result) => {
        setFuelData(result);
      }
    );
    repairApi.getItemNew(
      (result) => {
        setRepairData(result);
      }
    );
  }, []); 

  return (
    <AppRender apiCall={fetchData}>
      {(tmsData && fuelData && repairData) && 
        <View tmsObj={tmsData} fuelObj={fuelData} repairObj={repairData} />}
    </AppRender>
  );
};

export default Page;
